import http from 'axios'

export default {
  getInfosCereales: (username) => http.get(`/web/v1/${username}/abonnements`),
  getTousConseillers: (username) => http.get(`/web/v1/${username}/tous-conseillers`)
}
